import { useDraggableContainer } from 'hooks/useDraggableContainer';
import { useFadeVisibility } from 'hooks/useFadeVisibility';
import { useTemperatureUnitContext } from "context/TemperatureUnitContext";
import * as React from 'react';
import { Link, useIntl, FormattedMessage } from 'gatsby-plugin-react-intl';
import { SliderButton } from "./SliderButton";
import { StatsCard } from "./StatsCard";
import { Degrees } from "components/shared/Degrees";
import isBrowser from 'services/isBrowser';
import firstCapitalCase from 'services/firstCapitalCase';
import { WeatherData } from 'templates/fragments/weather-data';
import { prepareNumber } from 'services/prepareNumber';
import { convertToInches } from 'services/convertUnits';
import { measureColors } from 'services/measureColors';


type StatCardsWrapperProps = {
    scrollRef: React.RefObject<any>
    weatherData: WeatherData,
    monthIndex: number
}

export const StatCardsWrapper = (
    { scrollRef,
        weatherData,
        monthIndex
    }: StatCardsWrapperProps) => {
    const numOfCards = weatherData.sst[monthIndex] ? 7 : 6
    const statCardsWidth = 180 * numOfCards
    const [itemsWidthWiderThanWindow, setItemsWidthWiderThanWindow] = React.useState(false)
    const { mouseDownHandler, mouseUpHandler } = useDraggableContainer(scrollRef, itemsWidthWiderThanWindow)
    const { fadeVisible, mouseReleaseHandler } = useFadeVisibility(scrollRef, mouseUpHandler);
    let resizeTimeout: any = null;
    const onResize = () => {
        if (resizeTimeout) clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            
            if (scrollRef?.current?.children) {
                let width = 50;
                for (let child of scrollRef?.current?.children) {
                    width += 16 + child.offsetWidth;
                }
                setItemsWidthWiderThanWindow(width > window.innerWidth)
            }
        },20)
        
    }
    React.useEffect(() => {
        if (!isBrowser()) return;
        setTimeout(() => { onResize() }, 1);
        window.addEventListener('resize', onResize )
        return () => window.removeEventListener('resize', onResize)
    }, [])

    const intl = useIntl();
    const [unit] = useTemperatureUnitContext();
    return (
        <div className={`destination__stats--wrapper
            ${itemsWidthWiderThanWindow && 'draggable'} 
            ${fadeVisible.left && 'fade fade--stats fade--left'} 
            ${fadeVisible.right && 'fade fade--stats fade--right'}`}
            ref={scrollRef}
            onMouseDown={itemsWidthWiderThanWindow ? mouseDownHandler : () => { }}
            onMouseUp={itemsWidthWiderThanWindow ? mouseReleaseHandler : () => { }}
            onMouseLeave={itemsWidthWiderThanWindow ? mouseReleaseHandler : () => { }}
        >
            {itemsWidthWiderThanWindow && <div className="destination__stats__scrollBtn--right--wrapper"><SliderButton scrollRef={scrollRef} scrollDirectionLtR  /> </div>}
            <StatsCard iconType={'temperature'}
                title={firstCapitalCase(intl.formatMessage({ id: 'common.day' }))}
                mainStat={<Degrees degrees={weatherData.tmax[monthIndex]} />}
                color={measureColors['tmax']}
            />
            <StatsCard iconType={'nightTemperature'}
                title={firstCapitalCase(intl.formatMessage({ id: 'common.night' }))}
                mainStat={<Degrees degrees={weatherData.tmin[monthIndex]} />}
                color={measureColors['tmin']}
            />
            {weatherData.sst[monthIndex] && <StatsCard iconType={'seaTemperature'}
                title={firstCapitalCase(intl.formatMessage({ id: 'common.sea' }))}
                mainStat={<Degrees degrees={weatherData.sst[monthIndex]} />}
                color={measureColors['sst']}
            />}
            <StatsCard iconType={'rainyDays'}
                title={firstCapitalCase(intl.formatMessage({ id: 'common.measures.ppt' }))}
                mainStat={unit == 'C' ? `${prepareNumber(weatherData.ppt[monthIndex], 0)} mm` : `${prepareNumber(convertToInches(weatherData.ppt[monthIndex]), 2)} in`}
                additionalInfo={intl.formatMessage({ id: 'common.inAMonth' })}
                color={measureColors['ppt']}
            />
            <StatsCard iconType={'rainyDays'}
                title={firstCapitalCase(intl.formatMessage({ id: 'common.rainyDays' }))}
                mainStat={`${prepareNumber(weatherData.wet[monthIndex], 0)} ${intl.formatMessage({ id: 'common.daysGenitive' })}`}
                additionalInfo={intl.formatMessage({ id: 'common.inAMonth' })}
                color={measureColors['wet']}
            />
            <StatsCard iconType={'dayLight'}
                title={firstCapitalCase(intl.formatMessage({ id: 'common.dayLight' }))}
                mainStat={`${prepareNumber(weatherData.dayhrs[monthIndex], 0)} ${intl.formatMessage({ id: 'common.hoursGenitive' })}`}
                additionalInfo={intl.formatMessage({ id: 'common.avg' })}
                color={measureColors['dayhrs']}
            />
            {weatherData.sunhrs[monthIndex] && <StatsCard iconType={'sunshine'}
                title={firstCapitalCase(intl.formatMessage({ id: 'common.sunshine' }))}
                mainStat={`${prepareNumber(weatherData.sunhrs[monthIndex], 0)} ${intl.formatMessage({ id: 'common.hoursGenitive' })}`}
                additionalInfo={intl.formatMessage({ id: 'common.avg' })}
                color={measureColors['sunhrs']}
            />}
            {weatherData.rhm[monthIndex] && <StatsCard iconType={'humidity'}
                title={firstCapitalCase(intl.formatMessage({ id: 'common.humidity' }))}
                mainStat={`${prepareNumber(weatherData.rhm[monthIndex], 0)} %`}
                color={measureColors['rhm']}
            />}
            {itemsWidthWiderThanWindow && <div className="destination__stats__scrollBtn--wrapper"><SliderButton scrollRef={scrollRef} /></div>}
        </div>)
}


